import "./styles.css";
const Select = ({classname = "" , options , value , label , multiple = false , onChange , ...rest  }) => {
    const changeSelectedItems = (event) => {
        if (!multiple){
            onChange(event.target.value);
            return;
        }

        const options = event.target.options;
        const values = [];
        for (let i = 0, l = options.length; i < l; i++)
            if (options[i].selected)
                values.push(options[i].value);


        onChange(values);


    }

    return (
        <div className="card">
            <div className="card-body">
                {label && <label className="card-title mb-2">{label}</label>}
                <select value={value} multiple={multiple} className={`${multiple ? "custom-select form-control" : "custom-select form-select mb-3"} ${classname} `}  {...rest} onChange={(event) => {changeSelectedItems(event)} }>
                    {!multiple && options.map((option , index) => {
                        return (<option key={index}  value={option.value}>{option.label || option.value }</option>);
                    })
                    }
                    {multiple && options.map((option , index) => {
                        return (<option key={index}  value={option.value}>{option.label || option.value }</option>);
                    })
                    }
                </select>
            </div>
        </div>
    );
};

export const SelectWithoutContainer = ({classname = "" , options , value , label , multiple = false , onChange , ...rest  }) => {

    const changeSelectedItems = (event) => {
        if (!multiple){
            onChange(event.target.value);
            return;
        }

        const options = event.target.options;
        const values = [];
        for (let i = 0, l = options.length; i < l; i++)
            if (options[i].selected)
                values.push(options[i].value);


        onChange(values);


    }

    return (
        <div>
            {label && <label className="card-title mb-2">{label}</label>}
            <select value={value} multiple={multiple} className={`${multiple ? "custom-select form-control" : "custom-select form-select mb-3"} ${classname} `} {...rest} onChange={(event) => {changeSelectedItems(event)} }>
                {!multiple && options.map((option , index) => {
                    return (<option key={index}  value={option.value}>{option.label || option.value }</option>);
                })
                }
                {multiple && options.map((option , index) => {
                    return (<option key={index}  value={option.value}>{option.label || option.value }</option>);
                })
                }
            </select>
        </div>
    );
};

export default Select;
